import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2cba7fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "courierslist" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-3 lg:grid-cols-3" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_6 = { class: "flex items-center justify-end mt-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!
  const _component_courier_form = _resolveComponent("courier-form")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_couriers_table_actions_button = _resolveComponent("couriers-table-actions-button")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.delete_state.is_opened)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "large courierslist__modal",
          title: "Удаление курьера",
          "confirm-button-class": "small red",
          "confirm-message": `Вы действительно хотите удалить курьера ${
                _ctx.delete_state.courier ? _ctx.delete_state.courier.fullName : '-'
            }?`,
          "is-confirm": true,
          loading: _ctx.delete_state.is_loading,
          onCancel: _ctx.cancelDelete,
          onConfirm: _ctx.confirmDelete
        }, null, 8, ["confirm-message", "loading", "onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_courier_form, {
          key: 1,
          loading: _ctx.actions_state.is_actions_loading,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.createCourier,
          onUpdate: _ctx.updateCourier
        }, null, 8, ["loading", "is-create", "is-update", "initial-value", "onCreate", "onUpdate"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_page_title, { title: "Курьеры" }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_the_button, {
                class: "primary small mr-2",
                onClick: _ctx.startCreate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить курьера ")
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_the_button, {
                class: "primary small",
                onClick: _ctx.createJira,
                loading: _ctx.jira_state.is_loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить курьеров через Jira ")
                ]),
                _: 1
              }, 8, ["onClick", "loading"])
            ])
          ]),
          _createElementVNode("form", {
            class: "mt-6 mb-6 px-6 py-4 border bg-white",
            onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchCourier && _ctx.searchCourier(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_the_input, {
                placeholder: "ФИО",
                value: _ctx.filters_state.full_name,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters_state.full_name) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                placeholder: "ИИН",
                value: _ctx.filters_state.iin,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters_state.iin) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                placeholder: "Номер телефона",
                value: _ctx.filters_state.phoneNumber,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.phoneNumber) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                value: _ctx.filters_state.company_id,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters_state.company_id) = $event)),
                placeholder: "Поставщик",
                loading: _ctx.data_state.carriers.is_loading,
                options: _ctx.data_state.carriers.list,
                failed: _ctx.data_state.carriers.is_failed,
                "error-text": "При получении списка поставщиков произошла ошибка",
                "search-by": "name",
                "select-by": "id",
                label: "name",
                "infinite-scroll": "",
                "search-without-refresh": "",
                onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.carriers.pagination.current_page))),
                onLoadmore: _cache[6] || (_cache[6] = ($event: any) => (
                            _ctx.loadMoreCarriers(_ctx.data_state.carriers.pagination.current_page + 1)
                        )),
                onSearch: _ctx.searchCarriers,
                onOptionBySearch: _ctx.unshiftFindedCarrier
              }, null, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                value: _ctx.filters_state.dispatchers_sector_id,
                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.dispatchers_sector_id) = $event)),
                placeholder: "Cектор диспетчера",
                loading: _ctx.data_state.dispatchers_sectors.is_loading,
                options: _ctx.data_state.dispatchers_sectors.list,
                failed: _ctx.data_state.dispatchers_sectors.is_failed,
                "error-text": "При получении списка секторов диспетчера произошла ошибка",
                "search-by": "name",
                "select-by": "id",
                label: "name",
                onRefresh: _ctx.loadDispatchersSectors
              }, null, 8, ["value", "loading", "options", "failed", "onRefresh"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                value: _ctx.filters_state.status_id,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters_state.status_id) = $event)),
                placeholder: "Cтатус",
                loading: false,
                options: _ctx.COURIER_STATUSES,
                searchable: false,
                failed: false,
                "error-text": "При получении списка статусов произошла ошибка",
                "search-by": "name",
                "select-by": "id",
                label: "name"
              }, null, 8, ["value", "options"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                value: _ctx.filters_state.car_id,
                "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters_state.car_id) = $event)),
                placeholder: "Авто",
                loading: _ctx.data_state.cars.is_loading,
                options: _ctx.data_state.cars.list,
                failed: _ctx.data_state.cars.is_failed,
                "error-text": "При получении списка авто произошла ошибка",
                "search-by": "number",
                "select-by": "id",
                "infinite-scroll": "",
                onRefresh: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadCars(_ctx.data_state.cars.pagination.current_page))),
                onLoadmore: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadMoreCars(_ctx.data_state.cars.pagination.current_page + 1))),
                onSearch: _ctx.searchCars,
                onOptionBySearch: _ctx.unshiftFindedCars
              }, {
                "selected-option": _withCtx(({ option }) => [
                  (option.company)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number) + " (" + _toDisplayString(option.company.name) + ") ", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1)
                      ], 64))
                ]),
                option: _withCtx(({ option }) => [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, _toDisplayString(option.model) + ", " + _toDisplayString(option.number), 1),
                    (option.company)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(option.company.name), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["value", "loading", "options", "failed", "onSearch", "onOptionBySearch"]),
              _createVNode(_component_the_input, {
                placeholder: "ID",
                value: _ctx.filters_state.id,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filters_state.id) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_select, {
                "can-deselect": "",
                class: "mt-2",
                value: _ctx.filters_state.typesIds,
                "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters_state.typesIds) = $event)),
                placeholder: "Тип курьера",
                loading: _ctx.data_state.types.is_loading,
                options: _ctx.data_state.types.list,
                failed: _ctx.data_state.types.is_failed,
                searchable: false,
                "error-text": "При получении списка типов курьера произошла ошибка",
                "search-by": "title",
                "select-by": "id",
                label: "title",
                multiselect: "",
                onRefresh: _ctx.loadTypes
              }, null, 8, ["value", "loading", "options", "failed", "onRefresh"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_the_button, {
                class: "second text small mr-3",
                loading: _ctx.couriers_copy.is_search,
                onClick: _ctx.resetFilter
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createTextVNode(" Сбросить ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]),
              _createVNode(_component_the_button, {
                class: "primary text small w-fit",
                loading: _ctx.couriers_copy.is_search,
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" Поиск ")
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ], 32),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
              ? (_openBlock(), _createBlock(_component_failed_fetch, {
                  key: 0,
                  loading: _ctx.state.is_loading,
                  text: "При получении списка курьеров произошла ошибка",
                  "error-message": _ctx.state.failure.error_state.message,
                  "error-url": _ctx.state.failure.error_state.url,
                  "error-status": _ctx.state.failure.error_state.status,
                  onRefresh: _cache[15] || (_cache[15] = ($event: any) => (_ctx.loadCouriers(_ctx.state.pagination.current_page)))
                }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
              : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                  key: 1,
                  loading: _ctx.state.is_loading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_table, {
                      loading: _ctx.state.is_loading,
                      columns: _ctx.CouriersColumns,
                      rows: _ctx.state.list,
                      "with-limit": "",
                      "pagination-limit": _ctx.pagination_state.limit,
                      "pagination-total-items": _ctx.state.pagination.total_items,
                      "pagination-current-page": _ctx.state.pagination.current_page,
                      "pagination-total-pages": _ctx.state.pagination.total_pages,
                      onChangePage: _ctx.loadCouriers,
                      onChangeLimit: _ctx.onLimitChange
                    }, {
                      buttons: _withCtx(() => [
                        _createVNode(_component_the_button, {
                          class: "primary text small mr-3",
                          onClick: _ctx.exportExcel,
                          loading: _ctx.excel_state.is_loading,
                          hint: "Скачать в Excel"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ]),
                      td: _withCtx(({ column, row }) => [
                        (column.key === 'fullName')
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              target: "_blank",
                              class: "couriersList__link",
                              to: `/couriers/${row.id}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row[column.key]) + " ", 1),
                                _createElementVNode("p", null, _toDisplayString(row.iin), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (column.key === 'company')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (row.company)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.cutName(row.company.name, 10)), 1)
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("-")
                                    ], 64))
                              ], 64))
                            : (column.key === 'dispatcherSector')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  (row.dispatcherSector)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(row.dispatcherSector.name), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode("-")
                                      ], 64))
                                ], 64))
                              : (column.key === 'car')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    (row.car)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(_toDisplayString(_ctx.cutName(row.car.number, 10)) + ", " + _toDisplayString(_ctx.cutName(row.car.model, 20)), 1)
                                        ], 64))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode("-")
                                        ], 64))
                                  ], 64))
                                : (column.key === 'createdAt')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                      _createTextVNode(_toDisplayString(_ctx.formatDateWithTimeFromBackend(row.createdAt)), 1)
                                    ], 64))
                                  : (column.key === 'status')
                                    ? (_openBlock(), _createBlock(_component_cheap, {
                                        key: 5,
                                        class: _normalizeClass(["small", {
                                        yellow: row[column.key].id === 1,
                                        green: row[column.key].id === 2,
                                        red: row[column.key].id === 4,
                                    }])
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(row[column.key].title), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["class"]))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                        _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                                      ], 64))
                      ]),
                      actions: _withCtx(({ row }) => [
                        _createVNode(_component_couriers_table_actions_button, {
                          courier: row,
                          onUpdate: _ctx.startUpdate,
                          onDelete: _ctx.startDelete
                        }, null, 8, ["courier", "onUpdate", "onDelete"])
                      ]),
                      _: 1
                    }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                  ]),
                  _: 1
                }, 8, ["loading"]))
          ])
        ], 64))
  ]))
}